<template>
    <div class="modal-dialog modal-dialog-centered modal-xxl-90" >
        <div class="modal-content"  >
            <div class="modal-header bg-primary py-7 d-flex justify-content-between">
                <h2 class="text-white"> {{ $t('stock_transaction_list') }} </h2>
                <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" ::aria-label="$t('close')" ref="closeAccountReportDetailList" @click="onCloseModal()">
                    <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                        </svg>
                    </span>
                </div>
            </div>
            <div class="modal-body p-5 scroll-y" >
                <div class="row mt-5">
                    <div class="col-lg-12 col-sm-12 mt-5">
                        <div class="card h-xl-100">
                            <div class="card-body py-3">
                                <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                                    <div class="table-responsive min-h-300px">
                                        <DxDataGrid id="gridContainer" :key="$i18n.locale" 
                                                :show-borders="true" 
                                                key-expr="id" 
                                                :data-source="accountList" 
                                                :allow-column-reordering="true"  
                                                :allow-column-resizing="true" 
                                                :column-auto-width="true" 
                                                :row-alternatin-enabled="true"
                                                :hover-state-enabled="true" 
                                                :show-row-lines="true" 
                                                :ref="'dataGrid'" > 
                                                
                                                <DxFilterRow :visible="true"/>
                                                <DxHeaderFilter :visible="true"/>
                                                <DxGroupPanel :visible="true"/>      
                                                <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                                <DxPaging :page-size="30"/>
                                                <DxPager :visible="true" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/>
                                                <DxSearchPanel :visible="true"/> 
                                                
                                                <DxColumn data-field="transaction_date"  data-type="date" alignment="right" format="dd.MM.yyyy" :caption="$t('transaction_date')" header-cell-template="transaction-date-header" cell-template="transaction_date-cell-template"/>
                                                <DxColumn data-field="stk_product_code" :caption="$t('product_code')" header-cell-template="stk_product_code-header" cell-template="product_code-cell-template"/>
                                                <DxColumn data-field="stock_account_name" :caption="$t('stock')" cell-template="stock_account_name-cell-template"/>
                                                <DxColumn data-field="in_out_name" :caption="$t('in_out')" header-cell-template="inout-type-header" cell-template="in_out_name-cell-template"/>  
                                                <DxColumn data-field="quantity1" :sorting-method="this.$numericSort" :caption="$t('quantity_1')"  alignment="right" cell-template="quantity1-cell-template"/>
                                                <DxColumn data-field="quantity2" :sorting-method="this.$numericSort" :caption="$t('quantity_2')"  alignment="right" cell-template="quantity2-cell-template"/>
                                                <DxColumn data-field="unit1_name" :caption="$t('unit_1')" cell-template="unit1_name-cell-template"/>
                                                <DxColumn data-field="price" :sorting-method="this.$numericSort" :caption="$t('price')" alignment="right" cell-template="price-cell-template"/>
                                                <DxColumn data-field="total_price" :sorting-method="this.$numericSort" :caption="$t('total_price')"  alignment="right" header-cell-template="total-price-header" cell-template="total_price-cell-template"/>
                                                <DxColumn data-field="currency" :caption="$t('currency')" cell-template="currency-cell-template"/>
                                                <DxColumn data-field="discount" :sorting-method="this.$numericSort" :caption="$t('discount')"  alignment="right" cell-template="discount-cell-template"/>
                                                <DxColumn data-field="discount_amount" :sorting-method="this.$numericSort" :caption="$t('discount_amt')"  alignment="right" header-cell-template="discount-amount-header" cell-template="discount_amount-cell-template"/> 
                                                <DxColumn data-field="net_price" :sorting-method="this.$numericSort" :caption="$t('net_price')" alignment="right" header-cell-template="net-price-header" cell-template="net_price-cell-template"/> 
                                                <DxColumn data-field="tax_amount" :sorting-method="this.$numericSort" :caption="$t('tax_amt')" alignment="right" header-cell-template="tax-amount-header" cell-template="tax_amount-cell-template"/> 
                                                <DxColumn data-field="tax_rate" :sorting-method="this.$numericSort" :caption="$t('tax_rate')"  alignment="right" header-cell-template="tax-rate-header" cell-template="tax_rate-cell-template"/> 
                                                <DxColumn data-field="gross_amount" :sorting-method="this.$numericSort" :caption="$t('gross_amt')" alignment="right"  header-cell-template="gross-amount-header" cell-template="gross_amount-cell-template"/> 
                                                <DxColumn data-field="product_group_name" :caption="$t('product_group')" header-cell-template="product-group-header" cell-template="product_group_name-cell-template"/> 
                                                <DxColumn data-field="product_type_name" :caption="$t('product_type')" header-cell-template="product-type-header" cell-template="product_type_name-cell-template"/> 
                                                <DxColumn data-field="stock_code" :caption="$t('stock_code')" header-cell-template="stock_code-header" cell-template="stock_code-cell-template"/>
                                                <DxColumn data-field="record_date" data-type="date" alignment="right" format="dd.MM.yyyy" header-cell-template="record-date-header" :caption="$t('record_date')" cell-template="record_date-cell-template"/>
                                                <template #record-date-header>
                                                    <div>{{ $t('record_date') }}</div>
                                                </template>
                                                <template #stk_product_code-header>
                                                    <div>{{ $t('product_code') }}</div>
                                                </template>
                                                <template #stock_code-header>
                                                    <div>{{ $t('stock_code') }}</div>
                                                </template>
                                                <template #invoice-type-header>
                                                    <div>{{ $t('sub_type') }}</div>
                                                </template>
                                                <template #inout-type-header>
                                                    <div>{{ $t('in_out') }}</div>
                                                </template>
                                                <template #product-group-header>
                                                    <div>{{ $t('product_group') }}</div>
                                                </template>
                                                <template #product-type-header>
                                                    <div>{{ $t('product_type') }}</div>
                                                </template>
                                                <template #transaction-date-header>
                                                    <div>{{ $t('transaction_date') }}</div>
                                                </template>
                                                <template #discount-amount-header>
                                                    <div>{{ $t('discount_amount') }}</div>
                                                </template>
                                                <template #total-price-header>
                                                    <div>{{ $t('total_price') }}</div>
                                                </template>
                                                <template #net-price-header>
                                                    <div>{{ $t('net_price') }}</div>
                                                </template>
                                                <template #tax-amount-header>
                                                    <div>{{ $t('tax_amount') }}</div>
                                                </template>
                                                <template #tax-rate-header>
                                                    <div>{{ $t('tax_rate') }}</div>
                                                </template>
                                                <template #gross-amount-header>
                                                    <div>{{ $t('gross_amount') }}</div>
                                                </template>

                                                <!-- Cell Templates --> 
                                                <template #record_date-cell-template="{ data }"> 
                                                    <span class="align-middle text-end">
                                                        {{ previewDate(data.data.record_date) }} 
                                                    </span>
                                                </template>
                                                <template #stock_account_name-cell-template="{ data }"> 
                                                    <span class="align-middle">
                                                        {{ data.data.stock_account_name }} <small v-if="data.data.is_bundle_product == 1" class="ms-2 badge badge-sm badge-success">{{ $t('bundle') }}</small>
                                                    </span>
                                                </template>
                                                <template #product_code-cell-template="{ data }"> 
                                                    <span class="align-middle">
                                                        {{ data.data.stk_product_code }}
                                                    </span>
                                                </template>
                                                <template #stock_code-cell-template="{ data }"> 
                                                    <span class="align-middle">
                                                        {{ data.data.stock_code }}
                                                    </span>
                                                </template>
                                                <template #transaction_type_name-cell-template="{ data }"> 
                                                    <span class="align-middle" :class="{ 'text-primary': data.data.transaction_type == '11', 'text-info': data.data.transaction_type == '12'}">
                                                        {{ data.data.transaction_type_name }}
                                                    </span>
                                                </template>
                                                <template #invoice_type_name-cell-template="{ data }"> 
                                                    <span class="align-middle">
                                                        {{ data.data.invoice_type_name }}
                                                    </span>
                                                </template>
                                                <template #in_out_name-cell-template="{ data }"> 
                                                    <span class="align-middle">
                                                        {{ data.data.in_out_name }}
                                                    </span>
                                                </template>
                                                <template #transaction_no-cell-template="{ data }"> 
                                                    <span class="align-middle">
                                                        {{ data.data.transaction_no }}
                                                    </span>
                                                </template>
                                                <template #transaction_date-cell-template="{ data }"> 
                                                    <span class="align-middle text-end">
                                                        {{ previewDate(data.data.transaction_date) }}
                                                    </span>
                                                </template>
                                                <template #option_date-cell-template="{ data }"> 
                                                    <span class="align-middle text-end">
                                                        {{ previewDate(data.data.option_date) }}
                                                    </span>
                                                </template>
                                                <template #quantity1-cell-template="{ data }"> 
                                                    <span class="align-middle text-end">
                                                        {{ data.data.quantity1 }}
                                                    </span>
                                                </template>
                                                <template #quantity2-cell-template="{ data }"> 
                                                    <span class="align-middle text-end">
                                                        {{ data.data.quantity2 }}
                                                    </span>
                                                </template>
                                                <template #unit1_name-cell-template="{ data }"> 
                                                    <span class="align-middle">
                                                        {{ data.data.unit1_name }}
                                                    </span>
                                                </template>
                                                <template #price-cell-template="{ data }"> 
                                                    <span class="align-middle text-end">
                                                        {{ data.data.price }}
                                                    </span>
                                                </template>
                                                <template #total_price-cell-template="{ data }"> 
                                                    <span class="align-middle text-end">
                                                        {{ data.data.total_price }}
                                                    </span>
                                                </template>
                                                <template #currency-cell-template="{ data }"> 
                                                    <span class="align-middle">
                                                        {{ data.data.currency }}
                                                    </span>
                                                </template>
                                                <template #discount-cell-template="{ data }"> 
                                                    <span class="align-middle text-end">
                                                        {{ data.data.discount }}
                                                    </span>
                                                </template>
                                                <template #discount_amount-cell-template="{ data }"> 
                                                    <span class="align-middle text-end">
                                                        {{ data.data.discount_amount }}
                                                    </span>
                                                </template>
                                                <template #net_price-cell-template="{ data }"> 
                                                    <span class="align-middle text-end">
                                                        {{ data.data.net_price }}
                                                    </span>
                                                </template>
                                                <template #tax_amount-cell-template="{ data }"> 
                                                    <span class="align-middle text-end">
                                                        {{ data.data.tax_amount }}
                                                    </span>
                                                </template>
                                                <template #tax_rate-cell-template="{ data }"> 
                                                    <span class="align-middle text-end">
                                                        {{ data.data.tax_rate }}
                                                    </span>
                                                </template>
                                                <template #gross_amount-cell-template="{ data }"> 
                                                    <span class="align-middle text-end">
                                                        {{ data.data.gross_amount }}
                                                    </span>
                                                </template>
                                                <template #vendor_commission-cell-template="{ data }"> 
                                                    <span class="align-middle text-end">
                                                        {{ data.data.vendor_commission }}
                                                    </span>
                                                </template>
                                                <template #product_group_name-cell-template="{ data }"> 
                                                    <span class="align-middle">
                                                        {{ data.data.product_group_name }}
                                                    </span>
                                                </template>
                                                <template #product_type_name-cell-template="{ data }"> 
                                                    <span class="align-middle">
                                                        {{ data.data.product_type_name }}
                                                    </span>
                                                </template>
                                             

                                                <DxSummary :calculate-custom-summary="setSummaries">
                                                <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="record_date"/>
                                                <DxGroupItem
                                                    :show-in-group-footer="true"
                                                    name="discount_amount"
                                                    summary-type="custom"
                                                    show-in-column="discount_amount"
                                                    display-format="{0}"
                                                    /> 
                                                    <DxGroupItem
                                                    :show-in-group-footer="true"
                                                    name="gross_amount"
                                                    summary-type="custom"
                                                    show-in-column="gross_amount"
                                                    display-format="{0}"
                                                    /> 
                                                    <DxGroupItem
                                                    :show-in-group-footer="true"
                                                    name="quantity1"
                                                    summary-type="custom"
                                                    show-in-column="quantity1"
                                                    display-format="{0}"
                                                    />
                                                    <DxGroupItem
                                                    :show-in-group-footer="true"
                                                    name="quantity2"
                                                    summary-type="custom"
                                                    show-in-column="quantity2"
                                                    display-format="{0}"
                                                    />  
                                                    <DxGroupItem
                                                    :show-in-group-footer="true"
                                                    name="tax_amount"
                                                    summary-type="custom"
                                                    show-in-column="tax_amount"
                                                    display-format="{0}"
                                                    />  
                                                    <DxTotalItem
                                                        name="discount_amount"
                                                        summary-type="custom"
                                                        show-in-column="discount_amount"
                                                    />
                                                    <DxTotalItem
                                                        name="gross_amount"
                                                        summary-type="custom"
                                                        show-in-column="gross_amount"
                                                    />
                                                    <DxTotalItem
                                                        name="quantity1"
                                                        summary-type="custom"
                                                        show-in-column="quantity1"
                                                    />
                                                    <DxTotalItem
                                                        name="quantity2"
                                                        summary-type="custom"
                                                        show-in-column="quantity2"
                                                    />
                                                    <DxTotalItem
                                                        name="tax_amount"
                                                        summary-type="custom"
                                                        show-in-column="tax_amount"
                                                    />
                                                </DxSummary>

                                                <DxStateStoring
                                                    :enabled="true"
                                                    type="custom"
                                                    :storage-key="this.storageKey"
                                                    :ref="dataGrid" 
                                                    :saving-timeout="1000"
                                                    :custom-load="LoadDXState"
                                                />
                                        </DxDataGrid>   
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment'; 
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxSummary, DxTotalItem } from 'devextreme-vue/data-grid';
export default {
    name: 'AccountReportDetailList',
    components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxSummary, DxTotalItem
    },
    props:{

    },
    data() {
        return {
            accountList: [],
            isListProgressing: false,
            summary:[],
        }
    },
    computed: {
        showPageSizeSelector() {
            return this.accountList.length > this.pageSize;
        },
        pageSizes() {
            let arr = [];
            let x = 1;
            let loop = (this.accountList.length / this.pageSize);
            for (let i = 1; i <= loop && i <= 5; i++) {
                arr.push(this.pageSize * x);
                x++;
            }
            if(loop > 5) arr.push(100);
            if(loop > 1) arr.push('all');
            return arr;
        },
        previewDate(){
        return (value)=>{
            if (value) {
                return moment(new Date(value)).format('DD.MM.YYYY')
            }
        }
    },
    },
    methods: {     
        getData(invoiceId) {
            this.$Progress.start();
            this.isListProgressing = true;
            const params = {
                session_id: this.$getUser().session_id,
                first_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
                last_date: moment(),  
                in_out:0,
                stock_group: null,
                stock_name: null ,
                product_group: null ,
                product_type: null ,
                transaction_type: 0,
                transaction_subtype: 0,
                transaction_type_id: invoiceId
            };
            axios.post('/api/Transaction/GetAllStockTransactionList', params, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.accountList = response.data.transactions;
                    this.summary = response.data.summary;
                }
                this.$Progress.finish();
                setTimeout(() => {
                    this.isListProgressing = false;
                }, 500);
            })
            .catch((error) => {
                console.error(error);
                this.$Progress.finish();
                setTimeout(() => {
                    this.isListProgressing = false;
                }, 500);
            });  
         },
         setSummaries(options){
            if(options.name == "discount_amount") { options.totalValue = this.summary.discount_amount_local }
            if(options.name == "gross_amount") { options.totalValue = this.summary.gross_amount_local }
            if(options.name == "quantity1") { options.totalValue = this.summary.quantity1 }
            if(options.name == "quantity2") { options.totalValue = this.summary.quantity2 }
            if(options.name == "tax_amount") { options.totalValue = this.summary.tax_amount_local } 
        },
        /** DX STATE OPERATIONS **/  
        LoadDXState() {
            return JSON.parse(sessionStorage.getItem(this.storageKey));
        }, 
         onCloseModal() {
            this.$parent.AccountReportDetailList.click();
         }
    },
}
</script>